import { Button } from "@ternary/ui"
import { useState } from "react"

/**
 * The business's live address as a link, with "Copy address", on Settings → Address and the
 * onboarding Done panel. The copy is announced in the status line beside it, so it needs no toast
 * provider.
 */
export function LiveAddress({ url }: { url: string }) {
  const [notice, setNotice] = useState("")
  // The line breaks first before the base domain; a handle too long for the line breaks too.
  const host = url.replace(/^https?:\/\//, "")
  const dot = host.indexOf(".")
  const handle = dot > 0 ? host.slice(0, dot) : host
  const rest = dot > 0 ? host.slice(dot) : ""

  async function copy() {
    try {
      await navigator.clipboard.writeText(url)
      setNotice("Address copied.")
    } catch {
      setNotice("Select the address and copy it.")
    }
  }

  return (
    <div className="admin-live-address">
      <a href={url} rel="noreferrer" target="_blank">
        {handle}
        {rest ? (
          <>
            <wbr />
            {rest}
          </>
        ) : null}{" "}
        <span className="tny-visually-hidden">(opens in a new tab)</span>
      </a>
      <Button onClick={() => void copy()} size="sm" variant="secondary">
        Copy address
      </Button>
      <p className="admin-note" role="status">
        {notice}
      </p>
    </div>
  )
}
